const getButtonIcon = (
  isActive: boolean,
  activeIcon: string,
  defaultIcon: string
) => {
  return isActive ? activeIcon : defaultIcon
}

export default getButtonIcon
